
export const common = {
  sidebar: {
    title: "Back Office",
    dashboard: "Dashboard",
    kiosk: "Intake Kiosk (POS)",
    telemedicine: "Doctor Station",
    pharmacy: "Pharmacy",
    customers: "Registration / Reception",
    inventory: "Medical Stock",
    reports: "Reports",
    compliance: "Compliance",
    employees: "Staff Management",
    accounting: "Accounting",
    partnerNetwork: "Partner Network",
    billing: "Subscription",
    settings: "Settings",
    security: "Data Security (PDPA)",
    platformAdmin: "Super Admin Console",
    profile: "My Profile"
  },
  header: {
    logout: "Logout"
  },
  logoutConfirm: {
    title: "Confirm Logout",
    message: "Are you sure you want to log out?",
    confirmButton: "Logout"
  }
};
